import { render, staticRenderFns } from "./tab4.vue?vue&type=template&id=0e1c990e&scoped=true"
import script from "./tab4.vue?vue&type=script&lang=js"
export * from "./tab4.vue?vue&type=script&lang=js"
import style0 from "./tab4.vue?vue&type=style&index=0&id=0e1c990e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c990e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1c990e')) {
      api.createRecord('0e1c990e', component.options)
    } else {
      api.reload('0e1c990e', component.options)
    }
    module.hot.accept("./tab4.vue?vue&type=template&id=0e1c990e&scoped=true", function () {
      api.rerender('0e1c990e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/tab4.vue"
export default component.exports